/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../graphql/generated/types';

import { gql } from '@apollo/client';
export type BadRequestFragment = {
	__typename?: 'BadRequest';
	message: string;
	errors: Array<string>;
};

export type PaginationFragment = {
	__typename?: 'PaginationMetadata';
	total: number;
	page: number;
	pageSize: number;
	totalPages: number;
};

export type NotFoundErrorFragment = {
	__typename?: 'ResourceNotFound';
	message: string;
};

export type SearchDownloadResult_Forbidden_Fragment = {
	__typename?: 'Forbidden';
	message: string;
};

export type SearchDownloadResult_SearchDownloadLink_Fragment = {
	__typename?: 'SearchDownloadLink';
	downloadUrl: string;
	filename: string;
	totalRows: number;
	gdprRows: number;
};

export type SearchDownloadResultFragment =
	| SearchDownloadResult_Forbidden_Fragment
	| SearchDownloadResult_SearchDownloadLink_Fragment;

export type CountryFragment = {
	__typename?: 'Country';
	id: string;
	name: string;
	sortOrder?: number | null;
	count: number;
	states: Array<{
		__typename?: 'State';
		id: string;
		name: string;
		count: number;
	}>;
};

export type SpecialtyGroupFragment = {
	__typename?: 'SpecialtyGroup';
	id: string;
	name: string;
	count?: number | null;
	specialties: Array<{
		__typename?: 'Specialty';
		id: string;
		name: string;
		count?: number | null;
	}>;
};

export type HcpSearchAndFiltersFragment = {
	__typename?: 'HCPSearchAndFiltersType';
	searchString?: string | null;
	countries?: Array<string> | null;
	states?: Array<string> | null;
	specialtyGroups?: Array<string> | null;
	specialties?: Array<string> | null;
	hcpTypes?: Array<string> | null;
	hcos?: Array<string> | null;
	includeInactive: boolean;
};

export type HcoSearchAndFiltersFragment = {
	__typename?: 'HCOSearchAndFiltersType';
	searchString?: string | null;
	countries?: Array<string> | null;
	states?: Array<string> | null;
	hcoTypes?: Array<string> | null;
	includeInactive: boolean;
};

export const BadRequestFragmentDoc = gql`
	fragment BadRequest on BadRequest {
		message
		errors
	}
`;
export const PaginationFragmentDoc = gql`
	fragment Pagination on PaginationMetadata {
		total
		page
		pageSize
		totalPages
	}
`;
export const NotFoundErrorFragmentDoc = gql`
	fragment NotFoundError on ResourceNotFound {
		message
	}
`;
export const SearchDownloadResultFragmentDoc = gql`
	fragment SearchDownloadResult on SearchDownloadLinkForbidden {
		... on SearchDownloadLink {
			downloadUrl
			filename
			totalRows
			gdprRows
		}
		... on Forbidden {
			message
		}
	}
`;
export const CountryFragmentDoc = gql`
	fragment Country on Country {
		id
		name
		sortOrder
		count
		states {
			id
			name
			count
		}
	}
`;
export const SpecialtyGroupFragmentDoc = gql`
	fragment SpecialtyGroup on SpecialtyGroup {
		id
		name
		count
		specialties {
			id
			name
			count
		}
	}
`;
export const HcpSearchAndFiltersFragmentDoc = gql`
	fragment HCPSearchAndFilters on HCPSearchAndFiltersType {
		searchString
		countries
		states
		specialtyGroups
		specialties
		hcpTypes
		hcos
		includeInactive
	}
`;
export const HcoSearchAndFiltersFragmentDoc = gql`
	fragment HCOSearchAndFilters on HCOSearchAndFiltersType {
		searchString
		countries
		states
		hcoTypes
		includeInactive
	}
`;
